import { AnchorHTMLAttributes } from "react";

type ExternalLinkProps = AnchorHTMLAttributes<HTMLAnchorElement>;

export const ExternalLink = (props: ExternalLinkProps) => (
  <a target="_blank" rel="noreferrer" className="text-primary" {...props} />
);
